/**
 * 从数组创建一个 EntityCollection
 */
export var createEntityCollection = function (entityList, keySelector) {
    return {
        list: entityList.map(function (t) { return keySelector(t); }),
        entities: entityList.reduce(function (ret, item) {
            ret[keySelector(item)] = item;
            return ret;
        }, {}),
    };
};
/**
 * 将 EntityCollection 集合转换为普通数组
 */
export var convertToEntityList = function (collection) {
    return collection.list.map(function (key) { return collection.entities[key]; });
};
